import { render, staticRenderFns } from "./fppkNotificationAdd.vue?vue&type=template&id=6a7938aa&scoped=true"
import script from "./fppkNotificationAdd.vue?vue&type=script&lang=js"
export * from "./fppkNotificationAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7938aa",
  null
  
)

export default component.exports